// eslint-disable-next-line
/// <reference path="pug.d.ts" />
// @ts-check
'use strict';

const lex = require('pug-lexer');
const parse = require('pug-parser');
const walk = require('pug-walk');
const wrap = require('pug-runtime/wrap');
const generateCode = require('pug-code-gen');
const cloneDeep = require('lodash.clonedeep');
const { convertCodeToText } = require('./plugins/convert-code-to-text');
const { deleteDisallowTagAndAttribute } = require('./plugins/delete-disallow-tag-and-attribute');
const { escapeAst } = require('./plugins/escape-ast');
const { convertImg } = require('./plugins/convert-img');


/**
 * @param {PugAst.PugNode.AnyNode} node
 * @returns {PugAst.PugNode.AnyNode}
 */
const getConvertedAst = (node) => {
  const nodeConvertedImg = convertImg(node);

  return nodeConvertedImg;
};

/**
 * @param {PugAst.PugNode.AnyNode} node
 * @returns {PugAst.PugNode.AnyNode}
 */
const getSanitizedAst = (node) => {
  const nodeConvertedCode = convertCodeToText(node);
  const nodeDeleteDisallowTagAndAttribute = deleteDisallowTagAndAttribute(nodeConvertedCode);
  const nodeEscaped = escapeAst(nodeDeleteDisallowTagAndAttribute);

  return nodeEscaped;
};


/**
 * @param {PugAst.PugNode.AnyNode} node
 * @param {(newNode: PugAst.PugNode.AnyNode) => void} replace
 * @returns {void}
 */
const replaceAst = (node, replace) => {
  const clonedNode = cloneDeep(node);

  const converted = getConvertedAst(clonedNode);
  const sanitized = getSanitizedAst(converted);

  replace(sanitized);
};

/**
 * @param {string} source
 * @returns {string}
 */
const convertPugToSanitizedHtml = (source) => {
  // REF: pug の変換はここが参考になる: https://github.com/pugjs/pug/tree/master/packages/pug-walk

  const ast = parse(lex(source));
  const newAst = walk(ast, replaceAst);

  const pugCode = generateCode(newAst);
  return wrap(pugCode)();
};

module.exports = {
  convertPugToSanitizedHtml,
};
